import i18next from "i18next";
import { Navigate, ToolbarProps } from "react-big-calendar";
import DatePicker from "react-datepicker";

export const CalendarToolbar = (props: ToolbarProps) => {
  const goToBack = () => {
    props.onNavigate(Navigate.PREVIOUS);
  };

  const goToNext = () => {
    props.onNavigate(Navigate.NEXT);
  };

  const goToSpecificDate = (newDate: Date) => {
    props.onNavigate(Navigate.DATE, newDate);
  };
  return (
    <div>
      <div className="flex items-center px-2 pb-4 pt-8">
        <button
          onClick={goToBack}
          className="hover:text-600 contents w-6 text-[30px] leading-3"
        >
          &#8249;
        </button>
        <DatePicker
          className="flex-1"
          showPopperArrow
          dropdownMode="select"
          showMonthYearPicker
          selected={props.date}
          locale={i18next.language}
          onKeyDown={(e) => {
            e.preventDefault();
          }}
          dateFormat={"MMMM YYYY"}
          onChange={(date: any) => {
            goToSpecificDate(date);
          }}
        />
        <button
          className="hover:text-600 contents w-6 text-[30px] leading-3"
          onClick={goToNext}
        >
          &#8250;
        </button>
      </div>
    </div>
  );
};
